export default __webpack_public_path__ + "static/media/icon-test-taker.8d110295.svg";